<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">设备名称：</span>
        <el-input v-model="search.deviceName" :size="size" clearable placeholder="请输入设备名称"></el-input>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deviceName" label="设备名称" align="center" ></el-table-column>
        <el-table-column prop="deviceTypeName" label="设备类型" align="center" ></el-table-column>
        <el-table-column prop="snCode" label="SN码" align="center" ></el-table-column>
        <el-table-column prop="produceOrder" label="生产工序" align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" align="center" >
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增生产采集设备' : '修改生产采集设备'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="35%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="设备名称：" prop="deviceName">
          <el-input v-model="ruleForm.deviceName" :size="size" clearable placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="设备类型：" prop="deviceType">
          <el-select v-model="ruleForm.deviceType" placeholder="请选择设备类型">
                <el-option
                v-for="item in optionsType"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="SN码：" prop="snCode">
          <el-input v-model="ruleForm.snCode" :size="size" clearable placeholder="请输入SN码"></el-input>
        </el-form-item>
        <el-form-item label="生产工序：" prop="produceOrder">
          <el-input v-model="ruleForm.produceOrder" :size="size" clearable placeholder="请输入生产工序"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //设备管理信息列表
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {
        }, // 按钮表单
        rules: {
          deviceName: [{
            required: true,
            message: '请输入设备名称',
            trigger: 'blur'
          }],
          snCode: [{
            required: true,
            message: '请输入SM码',
            trigger: 'blur'
          }],
          deviceType: [{
            required: true,
            message: '请选择设备类型',
            trigger: 'change'
          }],
          produceOrder: [{
            required: true,
            message: '请输入生产工序',
            trigger: 'blur'
          }],
        },
        optionsType:[],//设备类型
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
      that.getAllTypes()
    },
    methods: {
    //获取尺寸配筋转向等信息
      getAllTypes(){
        let params = {
            pageNum: 1,
            pageSize: 100000000,
            dictType:9
        }
        this.$api.Dictionary.searchDictionary(params).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsType = res.data.list
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = true;
        this.$api.Device.searchProductDevice(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
      },
      // 修改按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.$api.Device.detailsProductDevice({deviceId: row.deviceId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
                let projectArr = []
                res.data.supplierPros.forEach(item=>{
                    projectArr.push(item.proId)
                })
                this.$set(this.ruleForm,'proIds',projectArr)
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Device.deleteProductDevice({deviceId: row.deviceId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            this.$api.Device.insertProductDevice(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            this.$api.Device.updateProductDevice(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../style/layout-main.scss';
</style>